/**
 * ------------------------------------------------------------------
 * DEFINIÇÃO DA ROTAS PARA APIS DO SISTEMA
 * ------------------------------------------------------------------
 *
 */
export let routeAddress = {
    /**
     * API: Auths (Autenticações)
     *
     * Lista de endpoints
     * [token] - Autenticar uma permissão de acesso ao sistema
     * [login] - Efetuar login
     * [logoff] - Efetuar logoff
     * [forgotPassword] - Esquecí minha senha
     * [changePassword] - Alterar senha
     *
     */
    route_auth_token: 'token/index',
    route_auth_login: 'auths/auth/login',
    route_auth_logoff: 'auths/auth/logoff',
    route_auth_request_password: 'auths/auth/forgotPassword',
    route_auth_change_password: 'auths/auth/changePassword',
    route_auth_validate: 'auths/auth/validateAccessCode',
    route_auth_get_me: 'auths/auth/getMe',
    route_auth_redirect_token: 'token/redirectionToken',

    /**
     * API: Users
     *
     * Lista de endpoints
     *
     */
    route_user_profile: 'users/user/profile',
    /**
     * @deprecated
     */
    route_user_insert_register: 'users/user/addRegister',
    route_user_update_profile: 'users/user/updProfile',
    route_user_change_avatar: 'users/user/changeAvatar',
    route_user_search: 'users/user/getSearch',

    route_user_set_register: 'users/user/setNewRegister',
    route_user_add_new_register: 'users/user/addNewRegister',
    route_user_send_authentication_code: 'users/user/sendAuthenticationCode',
    route_user_receive_authentication_code: 'users/user/receiveAuthenticationCode',
    route_user_recovery_methods: 'users/user/recoverPasswordMethod',
    route_user_recovery_found: 'users/user/recoverPasswordFound',
    /**
     * @deprecated
     */
    route_user_recovery_get_code: 'users/user/recoverPasswordSendCode',
    route_user_recovery_validate_code: 'users/user/recoverPasswordValidCode',
    route_user_update_password: 'users/user/updatePassword',

    /**
     * API: Locale
     *
     * Lista de endpoints
     * [locales/getCity] - Listar cidades por estado
     * [locales/getState] - Listar estados por pais
     * [locales/getCountry] - Listar paises disponíveis.
     */
    route_locale_city: 'locales/locales/getCity',
    route_locale_state: 'locales/locales/getState',
    route_locale_country: 'locales/locales/getCountry',

    /**
     * API: Searchs
     *
     * Lista de endpoints
     * [search/getSearch] - Realiza uma busca no sistema
     */
    route_search: 'searchs/search/getSearch',

    /**
     * API: Contacts
     *
     * Lista de endpoints
     * [contacts/addContact] - Criar nova solicitação de contato
     * [contacts/getRecipient] - Listar destinatários para contato
     *
     */
    route_recipient: 'contacts/contact_recipient/getRecipient',
    route_new_contact: 'contacts/contact/addContact',

    /**
     * API: Affiliated
     *
     * Lista de endpoints
     * [getAffiliated] - Listar entidades afiliadas ao site
     */
    route_affiliateds: 'affiliateds/affiliated/getAffiliated',

    /**
     * API: Affiliation
     *
     * Lista de endpoints
     * [getAffiliation] - Listar/gerenciar filiações de um atleta
     * [getFinancial] - Listar situação financeira de filiaçõs
     * [getListLicenses] - Listar filiações para escolha de compra
     * [getConfirmLicenses] - Buscar confirmação da escolha de compra
     * [addLicense] - Incluir nova compra de filiação
     * [cancelLicense] - Cancelar compra de filiação
     */
    route_affiliation: 'affiliates/affiliate/getAffiliate',
    route_affiliation_types: 'affiliates/affiliate/getMenuAffiliate',
    route_affiliation_financial: 'affiliates/affiliate/getFinancial',
    route_affiliation_list: 'affiliates/affiliate/getListLicenses',
    route_affiliation_confirm: 'affiliates/affiliate/getConfirmLicenses',
    route_affiliation_add: 'affiliates/affiliate/addLicense',
    route_affiliation_cancel: 'affiliates/affiliate/cancelLicense',
    route_affiliation_get_profile: 'affiliates/affiliate/getAffiliationProfile',
    route_affiliation_set_profile: 'affiliates/affiliate/setAffiliationProfile',
    route_affiliation_get_document_profile: 'affiliates/affiliate/getDocumentProfile',
    route_affiliation_set_document_profile: 'affiliates/affiliate/setDocumentProfile',
    route_affiliation_del_document_profile: 'affiliates/affiliate/delDocumentProfile',

    /**
     * API: Payments
     *
     * Lista de endpoints
     * [getBillingForm] - Listar formas de pagamento
     */
    route_payments_billing_form: 'payments/payment/getBillingForm',
    route_payments_pix: 'payments/payment/getPix',
    route_payments_confirm: 'payments/payment/paymentFromBank',
    route_payments_credit_card: 'payments/payment/cielo',

    /**
     * API: Certificate
     *
     * Lista de endpoints
     * [getCertificate] - Listar certificados e comprovantes
     */
    route_certificates: 'certificates/certificate/getCertificate',
    route_download_certificate: 'certificates/certificate/downloadCertificates',

    /**
     * API: Credit
     *
     * Lista de endpoints
     * [getCredit] - Listar lanctos de créditos
     */
    route_credit: 'credits/credit/getCredit',

    /**
     * API: News
     *
     * Lista de endpoints
     * [published_news/getNews] - Listar notícias
     * [published_news/getNews] - Detalhar notícia
     * [published_featured/getFeatured] - Listar destaques
     * [published_video/getVideo] - Listar videos
     * [published_slider/getSlider] - Listar banners para sliders da home
     *
     */
    route_detail_news: 'publisheds/published_news/getNews',
    route_news: 'publisheds/published_news/getNews',
    route_news_featured: 'publisheds/published_featured/getFeatured',
    route_news_videos: 'publisheds/published_video/getVideo',
    route_news_filter_videos: 'publisheds/published_video/getFilterVideo',
    route_news_sliders: 'publisheds/published_slider/getSlider',

    /**
     * API: Capacitations
     *
     * Lista de endpoints
     * [capactiations] - Listar registros com cadastros no módulo de
     * capacitação, de acordo como tipo: treinadores/árbitros.
     *
     */
    route_coach_list: 'capacitations/capacitation/getCapacitation',

    /**
     * API: Menus
     *
     * Lista de endpoints
     * [menu/getHeader] - Listar itens para menu Header
     * [menu/getFooter] - Listar itens para menu Footer
     * [menu/getSocial] - Listar itens para menu Social
     * [menu/getSidesBar] - Listar itens de menu lateral de um departamento
     * [menu/getContent] - Listar o conteúdo dinâmico de um item de menu customizado no sidebar
     */
    route_menu_header: 'menus/menu/getHeader',
    route_menu_footer: 'menus/menu/getFooter',
    route_menu_social: 'menus/menu/getSocial',
    route_menu_sidebar: 'menus/menu/getSidesBar',
    route_menu_content: 'menus/menu/getContent',

    /**
     * API: Partners
     *
     * Lista de endpoints
     * [partner/getPartner] - Listar banners/publicidades de parceiros
     */
    route_partners: 'partners/partner/getPartner',

    /**
     * API: Tournaments
     *
     * Lista de endpoints
     * [getTournamentList] - Listar torneios
     * [getTournament] - Detalhar torneio
     * [getFeatured] - Listar torneios em destaque
     * [getFinancialSituationSubscription] - Listar situações de inscrições
     * [getSubscriptionCategory] - Listar inscrições da categoria
     * [getSubscriptionConfirm] - Confirmar validação de dados para inscrição
     * [getSubscriptionInsert] - Incluir a inscrição na base do torneio
     * [getSubscriptionCancel] - Cancelar inscrição na base do torneio
     * [getGame] - Listar jogos
     * [getClassification] - Listar classificação
     * [getListGame] - Listar meus jogos
     * [tournament_program_central/getTournament] - Listar torneios configurados para utilizar a nova central de programação de jogos.
     */
    route_tournaments: 'tournaments/tournament/getTournamentList',
    route_tournaments_all: 'tournaments/tournament/getTournamentDepartmentList',
    route_tournament_detail: 'tournaments/tournament/getTournament',
    route_tournament_categories: 'tournaments/tournament/getTournamentCategory',
    route_tournaments_featured: 'tournaments/tournament/getFeatured',
    route_tournament_financial_situation: 'tournaments/tournament_subscription/getFinancialSituationSubscription',
    route_tournament_subscription_category: 'tournaments/tournament_subscription/getSubscriptionCategory',
    route_tournament_subscription_category_cancel: 'tournaments/tournament_subscription/getSubscriptionCategoryCancel',
    route_tournament_subscription_confirm: 'tournaments/tournament_subscription/getSubscriptionConfirm',
    route_tournament_subscription_insert: 'tournaments/tournament_subscription/getSubscriptionInsert',
    route_tournament_subscription_cancel: 'tournaments/tournament_subscription/getSubscriptionCancel',
    route_tournament_game: 'tournaments/tournament_game/getGame',
    route_tournament_game_bybox: 'tournaments/tournament_game/getGameByBox',
    route_tournament_classification: 'tournaments/tournament_classification/getClassification',
    route_tournament_mygames: 'tournaments/tournament_game/getGameList',
    route_tournament_program: 'tournaments/tournament_program/getProgram',
    route_tournament_program_category: 'tournaments/tournament_program/getProgramByCategory',
    route_tournament_player_trail: 'tournaments/tournament_program/getPlayerTrail',
    route_tournament_player_trail_filter: 'tournaments/tournament_program/getPlayerTrailFilter',
    route_tournament_program_now: 'tournaments/tournament_program_central/getProgramNow', //endpoint atualizado 10/06
    route_tournament_central_get: 'tournaments/tournament_program_central/getTournament',
    route_tournament_central_program_by_court: 'tournaments/tournament_program_central/getProgramByCourt',
    route_tournament_central_my_program_by_court: 'tournaments/tournament_program_central/getMyProgramByCourt',
    route_tournament_get_best_champions: 'tournaments/tournament/getBestChampions',
    route_tournament_send_cancel_confirmation_code: 'tournaments/tournament_subscription/sendCancelConfirmationCode',
    route_tournament_points: 'tournaments/tournament/getTournamentPointsByCategory',
    route_tournament_player_search: 'tournaments/tournament_program/getPlayerFromTournament',

    /**
     * API: Rankings
     *
     * Lista de endpoints
     * [rankings] - Listar rankings
     * [rankings_rating] - Listar classificação do ranking
     * [rankings_history] - Listar história de uma classificação anual
     */
    route_rankings: 'rankings/ranking/getRanking', // Listar rankings da entidade
    route_rankings_featured: 'rankings/ranking/getLastRanking', // Listar rankings da entidade
    route_rankings_filter: 'rankings/ranking/getFilter', // Listar ranking da entidade com filtros
    route_ranking_rating: 'rankings/ranking_rating/getRating', // Buscar lista de classificação
    route_ranking_history: 'rankings/ranking_history/getHistory', // Buscar lista de classificação
    route_ranking_detailed_points: 'rankings/ranking_rating/getDetailRating', // Buscar detalhes da pontuação do atleta
    route_ranking_best_movements: 'rankings/ranking_rating/getBestMoviment', // Buscar detalhes da pontuação do atleta
    route_ranking_international: 'rankings/ranking_international/getFilter', // Buscar rankings internacionais
    /**
     * API: Sites
     *
     * Lista de endpoints
     * [club] - Listar clubes
     * [resetClub] - Limpar clube do cadastro
     * [institutional] - Dados da página institucional
     * [faq] - Dados da página faq
     */
    route_site_club: 'sites/site/club',
    route_site_reset_club: 'sites/site/resetClub',
    route_site_institutional: 'sites/site/institutional',
    route_site_faq: 'sites/site/faq',
    route_site_entity: 'sites/site/entity',

    /**
     * API: Entidades
     */
    route_entity_get: 'entities/entity/get',
    route_entity_president: 'entities/entity/getPresident',
    route_entity_office: 'entities/entity/getOffice',
    route_entity_history: 'entities/entity/getHistory',

    route_clubs_get: 'clubs/club/get',

    // Desativar após mudar para novas apis
    route_department_id: 'setup/getDeptoIdByType', // Listar id do departamento

    /**
     * API: Setups
     *
     */
    route_setup: 'setups/setup/get',

    /**
     * API: Partners
     *
     */
    route_partners_certification: 'partners/partner/getCertification',
    /**
     * API: Privacy
     *
     */
    route_privacy_get: 'privacys/privacy/get',
    route_privacy_set: 'privacys/privacy/set',

    /**
     * API: Financeiro
     */

    // Atenção: rota para endpoint do app
    route_credit_card_get: 'financial/getCreditCard',
    route_credit_card_add: 'financial/addCreditCard',
    route_credit_card_update: 'financial/updCreditCard',

    /**
     * API: Payments
     *
     */
    route_payments_get: 'payments/payment/get',
    route_payments_update_financial: 'payments/payment/updFinancial',
    route_payments_billing_open: 'payments/payment/getBillingOpen',
    route_payments_bar_code: 'payments/payment/getBarcode',
    route_payments_get_billing: 'payments/payment/getFatura',

    /**
     * API: H2H
     *
     */
    route_h2h_get: 'h2hs/h2h/get',

    /**
     * API: Courts
     *
     */
    route_courts_location: 'controlcourts/controlcourt/getLocation',
    route_courts_availability: 'controlcourts/controlcourt/getLocationCourt',
    route_courts_by_local: 'controlcourts/controlcourt/getLocationCourtByLocal',
    route_courts_schedule_ranking: 'controlcourts/controlcourt/scheduleRanking',

    /**
     * API: Service Grid
     *
     */
    route_service_grid: 'servicegrids/servicegrid/get',
    route_service_purchase: 'servicegrids/servicegrid/set',
    route_service_cancel: 'servicegrids/servicegrid/cancel',
    route_service_user_cards: 'servicegrids/servicegrid/getUserCards',

    /**
     * API: Events
     *
     */
    /**
     * @deprecated
     */
    route_events_all: 'events/event/all',
    route_events_filter: 'events/event/getEventFilter',
    route_events_featured: 'events/event/lastEvents',
    route_events_details: 'events/event/getDetail',
    route_events_add: 'events/event/add',
    route_events_confirm: 'events/event/confirm',
    route_events_cancel: 'events/event/cancel',
    route_events_finance: 'events/event/getFinancial',

    /**
     * API: WTN
     *
     */
    route_wtn_ranking: 'wtns/wtn/getRating',
    route_wtn_register_link: 'wtns/wtn/getWTNRegisterLink',

    /**
     * API: DUPR
     */
    route_dupr_ranking: 'duprs/dupr/getRating',
    route_dupr_ranking_filters: 'duprs/dupr/getRatingFilters',
    route_dupr_register_link: 'duprs/dupr/getDUPRRegisterLink',
    route_dupr_sync_player_data: 'sites/site_organization/syncPlayerDataDUPR',
};
